import { render, staticRenderFns } from "./VEmojiPicker.vue?vue&type=template&id=2413c210&"
import script from "./VEmojiPicker.vue?vue&type=script&lang=js&"
export * from "./VEmojiPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports